import * as React from 'react'
import { TouchableOpacity, View } from 'react-native'

import { styles } from './styles'

export function Header(props: {
  leftContent: React.ReactNode
  centerContent: React.ReactNode
  rightContent: React.ReactNode
  leftPress: () => void
  rightPress: () => void
}) {
  const { leftContent, centerContent, rightContent, leftPress, rightPress } = props
  return (
    <View style={styles.headerContainer}>
      <View style={styles.itemLeft}>
        <TouchableOpacity onPress={leftPress}>{leftContent}</TouchableOpacity>
      </View>
      <View style={styles.itemCenter}>{centerContent}</View>
      <View style={styles.itemRight}>
        <TouchableOpacity onPress={rightPress}>{rightContent}</TouchableOpacity>
      </View>
    </View>
  )
}
